import { createExtension } from '@lexkit/editor';
import { $getSelection, $isRangeSelection, FORMAT_ELEMENT_COMMAND } from 'lexical';

export const alignmentExtension = createExtension({
  name: 'alignment' as const,
  commands: (editor) => ({
    alignLeft: () => {
      editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'left');
    },
    alignCenter: () => {
      editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'center');
    },
  }),
  stateQueries: (editor) => ({
    isAlignedLeft: async () => {
      let result = false;

      editor.getEditorState().read(() => {
        const selection = $getSelection();

        if (!$isRangeSelection(selection)) return;

        const node = selection.anchor.getNode().getTopLevelElement();

        if (!node) return;

        const format = node.getFormatType();

        result = format === 'left' || format === '';
      });

      return result;
    },
    isAlignedCenter: async () => {
      let result = false;

      editor.getEditorState().read(() => {
        const selection = $getSelection();

        if (!$isRangeSelection(selection)) return;

        const node = selection.anchor.getNode().getTopLevelElement();

        if (!node) return;

        result = node.getFormatType() === 'center';
      });

      return result;
    },
  }),
});
